import Content from "./Content";
import ContentFactory from "./ContentFactory";

export default class QuizAnswerImageContent extends Content {
    constructor(languagePack, contentID, answerText, label) {
        super(QuizAnswerImageContent.NAME, QuizAnswerImageContent.TYPE, label, languagePack, contentID);

        this._answerText = answerText;
        this._isCorrectAnswer = false;
        this._points;
        this.setAnswerText(label);
    }

    remove() {
        this.removeLanguagePackText(QuizAnswerImageContent.ANSWER_LABEL);
        this.removeLanguagePackText(QuizAnswerImageContent.IMAGE_LABEL);
        super.remove();
        this.dispatchEvent("propertyChange");
    }

    clone() {
        let clone;

        clone = QuizAnswerImageContent(ContentFactory.getContent(QuizAnswerImageContent.TYPE, this.languagePack));
        clone.contentID = this.contentID;
        clone._answerText = this._answerText;
        clone.setImage(this.getImage());
        clone._isCorrectAnswer = this._isCorrectAnswer;
        clone._points = this._points;
        return clone;
    }

    setAnswerText(value) {
        if (this._answerText !== value) {
            this.setLanguagePackText(QuizAnswerImageContent.ANSWER_LABEL, value);
            this.dispatchEvent("propertyChange");
        }
    }

    getAnswerText() {
        return this.getLanguagePackText(QuizAnswerImageContent.ANSWER_LABEL);
    }

    setImage(value) {
        this.setLanguagePackText(QuizAnswerImageContent.IMAGE_LABEL, value);
    }

    getImage() {
        return this.getLanguagePackText(QuizAnswerImageContent.IMAGE_LABEL);
    }

    setPoints(points) {
        this._points = points;
    }

    getPoints() {
        return this._points;
    }

    setIsCorrectAnswer(correct) {
        this._isCorrectAnswer = correct;
    }

    getIsCorrectAnswer(correct) {
        return this._isCorrectAnswer;
    }

    convertToObject() {
        return this.getObject(["isCorrectAnswer", "points"]);
    }
}

QuizAnswerImageContent.NAME = "Quiz Answer Image";
QuizAnswerImageContent.TYPE = "engQuizAnswerImageContent";
QuizAnswerImageContent.ANSWER_LABEL = "answer text";
QuizAnswerImageContent.IMAGE_LABEL = "answer image";
